import { NgModule } from '@angular/core';

import { LIB_CommonModule } from "pbc.angular";

import { DashboardService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [
    DashboardService,
  ],
  exports: []
})
export class DashboardServiceModule { }
